export const GET_JOBS = 'GET_JOBS';
export const LOADING_JOBS = 'LOADING_JOBS';
export const SAVE_LOADING_JOBS = 'SAVE_LOADING_JOBS';